import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert";
import { Country, State, City } from "country-state-city";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SessionsModal2 from "../../common/sessionsModal2";

import axios from "axios";
import moment from "moment";
import ModalVisible from "../../AdminModule/Dashboard/MentorDashboard/CohortGroupSession/Modal/modal";
import MultiselectorComp from "../../MultiselectorComp/MultiselectorComp";
import api from "../dependencies/utils/Api";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import Kalend, { CalendarView } from "kalend"; // import component
import "kalend/dist/styles/index.css"; // import styles
import CalendarCreateSession from "../calendarCreateSession";
import { getMentorCohortApplicationList } from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import {
  ALL_STARTUP_SEARCH_REQUEST_SUBMIT,
  ALL_STARTUP_SEARCH_REQUEST_SUBMIT_NEW,
  SESSION_CALENDAR,
  GET_DETAILS_COHORT_GROUP_SESSION,
  GROUP_SESSION_NAME_LIST,
  MY_MENTORSHIP_LIST,
  ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR,
  GET_LIST_COHORT_GROUP_SESSION,
  COHORT_NAME_LIST,
} from "../../common/constants/ApplicationUrl";
import { DoubleArrow, FiberManualRecordRounded } from "@material-ui/icons";

import { getPredefineOptionsList } from "../../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
import { getSessionCalendar } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";

import TextareaField from "../TextAreaField";
import { makeStyles } from "@material-ui/core/styles";

import "./styles.scss";

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
  },
}));
//Steps to use this component for data:
//1.Create a state variable and send the values as props to this component
//2.set the state here using props.
//3.inside the useEffect of parent , after the setState event occurs value will be reflected

//Steps to hide this Component
//1.create a set variable , use this to toggle visibility.
//2.send both the normal and setValue.
const ModalFilter2 = (props) => {
  const {
    registerMentor,
    getPredefineOptionsList,
    getPredefineOptions,
    getSessionCalendar,
    getCalendar,
    getMentorCohortApplicationList,
    cohortMentorData,
    showCohortsOnly,
  } = props;
  // const headermonth = document.querySelector(".Kalend__HeaderCalendarTitle");
  const headermonthandyear = document.querySelector(
    ".Kalend__HeaderCalendarTitle"
  );
  const rangedata = JSON.parse(localStorage.getItem("rangeData"));
  const slicedMonth = headermonthandyear?.innerHTML.slice(0, -5);

  const newModifiedMonth = new Date(headermonthandyear?.innerHTML);

  const [calendardata, setCalendardata] = useState([]);
  const [eventdata, setEventdata] = useState([]);
  const [data, setData] = useState();
  const [eventdata2, setEventdata2] = useState();
  const [headerCurrentMonthTitle, setheaderCurrentMonthTitle] = useState("");
  let activityArray = [];
  // const showActivityList = () => {
  //   let activityArray = [];

  //   calendardata?.data?.map((item, index) => {
  //     let param = {
  //       id: index + 1,
  //       startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
  //       endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
  //       // startAt: "2022-08-06T18:00:00.000Z",
  //       // endAt: "2022-08-06T19:00:00.000Z",
  //       timezoneStartAt: "UTC", // optional
  //       // summary: `${item.title.substring(0, 10)}...`,
  //       summary: `new`,
  //       color:
  //         // new Date(item.filterEndDate) < new Date() ? "#6aa3b2" : "#dbb63f",
  //         new Date(item.sessionEnd) < new Date() ? "#92a9b0" : "#4ce070",
  //       // new Date(newfilteredDate) < new Date() ?

  //       calendarID: "work",
  //     };
  //     activityArray.push(param);
  //   });

  //   setListactivityArray(activityArray);
  //   // setRequireId(activityArray?.id);
  // };

  var m = newModifiedMonth.getMonth();

  var y = newModifiedMonth.getFullYear();

  var firstDay = new Date(y, m, 1);
  var lastDay = new Date(y, m + 1, 0);

  const formatYmd = (date) => date.toISOString();

  var required = moment.utc(firstDay).format("YYYY-MM-DDThh:mm:ssZ");
  var required2 = moment.utc(lastDay).format("YYYY-MM-DDThh:mm:ssZ");

  const startOfMonth = moment
    .utc()
    .startOf("month")
    .format("YYYY-MM-DDThh:mm:ssZ");

  const endOfMonth = moment.utc().endOf("month").format("YYYY-MM-DDThh:mm:ssZ");

  useEffect(() => {
    // const data = {
    //   userId: loggedIn?.id,
    //   sessionStatus: "",
    //   startDate: startOfMonth,
    //   endDate: endOfMonth,
    // };

    // getSessionCalendar(data);

    // axios({
    //   url: SESSION_CALENDAR,
    //   method: "POST",
    //   data: {
    //     userId: loggedIn?.id,
    //     sessionStatus: "",
    //     // startDate: startOfMonth,
    //     startDate: rangedata?.rangeFrom,
    //     // endDate: endOfMonth,
    //     endDate: rangedata?.rangeTo,
    //   },
    // })
    if (
      props?.allCalendarData !== undefined &&
      props?.allCalendarData !== null &&
      props?.allCalendarData !== "" &&
      props?.allCalendarData
    ) {
      let params;
      if (
        props?.allCalendarData !== undefined &&
        props?.allCalendarData !== null &&
        props?.allCalendarData !== ""
      ) {
        params = {
          sessionStartDate:
            rangedata?.rangeFrom !== null
              ? rangedata?.rangeFrom
              : "2023-08-01T18:00:00.000Z",
          sessionEndDate:
            rangedata?.rangeTo !== null
              ? rangedata?.rangeTo
              : "2023-08-31T18:00:00.000Z",
          cohortId: props?.particularCohort,
        };
      } else {
        params = {
          sessionStartDate:
            rangedata?.rangeFrom !== null
              ? rangedata?.rangeFrom
              : "2023-08-01T18:00:00.000Z",
          sessionEndDate:
            rangedata?.rangeTo !== null
              ? rangedata?.rangeTo
              : "2023-08-31T18:00:00.000Z",
        };
      }

      api
        .POST(ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR, params)
        .then((res) => {
          // setCalendardata(res.data?.data);
          setEventdata2(res.data?.data);
        })
        .catch((err) => {});
    } else {
      api
        .POST(SESSION_CALENDAR, {
          userId: loggedIn?.id,
          sessionStatus: "",
          // startDate: startOfMonth,
          startDate: rangedata?.rangeFrom,
          // endDate: endOfMonth,
          endDate: rangedata?.rangeTo,
        })
        .then((res) => {
          setCalendardata(res.data?.data);
          // props.closeLoader()
        })
        .catch((err) => {});
    }
    // showActivityList();
    // setSession()
    // showActivityList();

    // VIEW_COUNTER_SESSIONS
  }, [localStorage.getItem("rangeData")]);

  // const showActivityList = () => {
  //   let activityArray = [];

  //   calendardata?.data?.map((item, index) => {
  //     let param = {
  //       id: item.scheduleId,
  //       startAt: moment(item.sessionDate).format("YYYY-MM-DDThh:mm:ssZ"),
  //       endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
  //       // startAt: "2022-08-06T18:00:00.000Z",
  //       // endAt: "2022-08-06T19:00:00.000Z",
  //       timezoneStartAt: "UTC", // optional
  //       // summary: `${item.title.substring(0, 10)}...`,
  //       summary: `new`,
  //       color:
  //         // new Date(item.filterEndDate) < new Date() ? "#6aa3b2" : "#dbb63f",
  //         new Date(item.sessionEnd) < new Date() ? "#92a9b0" : "#4ce070",
  //       // new Date(newfilteredDate) < new Date() ?

  //       calendarID: "work",
  //     };
  //     activityArray.push(param);
  //     // setnewfilteredDate(item.filterEndDate);
  //   });

  //   setListactivityArray(activityArray);
  //   // setRequireId(activityArray?.id);
  // };

  useEffect(() => {
    const headermonthandyear = document.querySelector(
      ".Kalend__HeaderCalendarTitle"
    );

    const headerCurrentMonth = document.querySelector(
      ".Kalend__HeaderCalendarTitle, .Kalend__HeaderCalendarTitle-dark, .Kalend__HeaderCalendarTitle-mobile"
    );

    setheaderCurrentMonthTitle(headerCurrentMonth?.innerHTML);
    // showActivityList();

    // calendardata?.data?.map((item, index) => {
    //   let param = {
    //     id: index + 1,
    //     startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
    //     endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
    //     // startAt: "2022-08-06T18:00:00.000Z",
    //     // endAt: "2022-08-06T19:00:00.000Z",
    //     timezoneStartAt: "UTC", // optional
    //     // summary: `${item.title.substring(0, 10)}...`,
    //     summary: `new`,
    //     color:
    //       // new Date(item.filterEndDate) < new Date() ? "#6aa3b2" : "#dbb63f",
    //       new Date(item.sessionEnd) < new Date() ? "#92a9b0" : "#4ce070",
    //     // new Date(newfilteredDate) < new Date() ?

    //     calendarID: "work",
    //   };
    //   // activityArray.push(param);
    //   // setActivityArray({ ...activityArray, param });
    //   setActivityArray((currentArray) => [...currentArray, param]);

    //   // setnewfilteredDate(item.filterEndDate);
    // });
  }, [calendardata, headerCurrentMonthTitle]);

  const newCountryArray = [];
  const newsubSpecialArray = [];
  const newsubArray = [];
  const newStateArray = [];
  const classes = useStyles();
  const defaultFormData2 = {
    search: "",
    industry: "",
    subindustry: [],
    specialization: "",
    subspecialization: [],
    stage: "",
    recognized: "",
    state: "",
    state_name: "",
    country: "",
  };
  const [show, setShow] = useState(false);
  const [errorMsg, setError] = useState(false);
  let errorMessageIndustry = ["*Please Select Industry"];
  let errorMessageIndustryKeywords = [
    "*Please Select Industry / Sector - Keywords",
  ];
  let errorMessageFunction = ["*Please Select function of Support"];
  let errorMessageFunctionKeywords = ["*Please Select Function - Keywords"];
  let errorMessageStage = ["*Please Select Stage"];
  const [scheduleModalOpen2, setScheduleModalOpen2] = useState(false);
  // let errorMessagePurpose = ["*Please Enter the purpose"];
  const [errorVisible, SetErrorVisible] = useState(false);
  const [errorVisible2, SetErrorVisible2] = useState(false);
  const [errorVisible3, SetErrorVisible3] = useState(false);
  const [errorVisible4, SetErrorVisible4] = useState(false);
  const [errorVisible5, SetErrorVisible5] = useState(false);
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the purpose"
  );
  // const [lgShow, setLgShow] = useState(props.modalVisibility);
  const [filterData, setFilterData] = useState();
  const [allCalendarDataArr, setAllCalendarDataArr] = useState([]);
  const [allCalendarDataArr2, setAllCalendarDataArr2] = useState([]);
  const [calendarStatus, setCalendarStatus] = useState("");
  const [calendarInitial, setCalendarInitial] = useState("");
  const [filterData2, setFilterData2] = useState([]);
  const [filterData3, setFilterData3] = useState();
  const [filterData4, setFilterData4] = useState([]);
  const [filterData5, setFilterData5] = useState();
  const [filterData6, setFilterData6] = useState();
  const [filterData7, setFilterData7] = useState();
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState("");
  const [formData, setFormData] = useState(defaultFormData2);
  const [rangeTo, setRangeTo] = useState();
  const [rangeFrom, setRangeFrom] = useState();
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [groupsessiondata, setGroupsessiondata] = useState({});
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [taggingList, setTaggingList] = useState([]);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [allSessionMentorList, setSessionAllMentorList] = useState();
  const [allSessionStartupList, setSessionAllStartupList] = useState();
  const [reloadCalendar, setReloadCalendar] = useState(false);
  const [intialDateRange, setIntialDateRange] = useState();
  const [filterCohortId, setFilterCohortId] = useState("");
  const [searchCohortId, setSearchCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minWidth: "15.75rem",
      maxWidth: "220px",
      // color: "#333",
      color: "rgb(121, 193, 206)",
      whiteSpace: "nowrap",
      fontSize: "16px",
      position: "relative",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      // minWidth: "100%",
      fontSize: "14px",
      zIndex: "1000",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
        whiteSpace: "nowrap",
        textAlign: "left",
        zIndex: "1000",
      };
    },
  };
  useEffect(() => {
    api
      .POST(COHORT_NAME_LIST, {
        mentorId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
        status: "VERIFIED",
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            if (item.name !== "" && item.name !== null) {
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
          });
      })
      .catch((err) => {});
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     mentorId: loggedIn?.role === "Admin" ? "" : loggedIn?.id,
    //   },
    // })
  }, []);
  // useEffect(() => {
  //   getPredefineOptionsList();
  //   Country.getAllCountries().map((item) => {
  //     const newObject = {
  //       value: item.isoCode,
  //       label: item.name,
  //     };

  //     newCountryArray.push(newObject);
  //     setNewCountryOptions(newCountryArray);
  //   });
  //   State.getStatesOfCountry("IN").map((item) => {
  //     const newObject = {
  //       value: item.isoCode,
  //       label: item.name,
  //     };

  //     newStateArray.push(newObject);

  //     setNewStateOptions(newStateArray);
  //   });
  // }, []);
  useEffect(() => {
    // document
    //   .querySelector(
    //     ".Kalend__button Kalend__ButtonBase-border .Kalend__ButtonBase"
    //   )
    //   .click();
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };
      newStateArray.push(newObject);

      setNewStateOptions(newStateArray);
    });
  }, []);
  // const showActivityList = () => {
  //   calendardata?.data?.map((item, index) => {
  //     let param = {
  //       id: index + 1,
  //       startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
  //       endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
  //       // startAt: "2022-08-06T18:00:00.000Z",
  //       // endAt: "2022-08-06T19:00:00.000Z",
  //       timezoneStartAt: "UTC", // optional
  //       // summary: `${item.title.substring(0, 10)}...`,
  //       summary: `new`,
  //       color:
  //         // new Date(item.filterEndDate) < new Date() ? "#6aa3b2" : "#dbb63f",
  //         new Date(item.sessionEnd) < new Date() ? "#92a9b0" : "#4ce070",
  //       // new Date(newfilteredDate) < new Date() ?

  //       calendarID: "work",
  //     };
  //     activityArray.push(param);
  //   });
  // };

  const endTime = moment(calendardata && calendardata[1]?.sessionEnd).format(
    "YYYY-MM-DDThh:mm:ssZ"
  );

  const newdatetime = moment(new Date()).format("YYYY-MM-DDThh:mm:ssZ");

  const testSessionTextVisibility = (item) => {
    let presentTime = moment().format("YYYY-MM-DD HH:mm A");
    let sessionEndTime = moment(item?.sessionEnd).format("YYYY-MM-DD HH:mm A");
    let endTime = moment(sessionEndTime, "YYYY-MM-DD HH:mm A")
      .add(60, "minutes")
      .format("YYYY-MM-DD HH:mm A");
    let testerYear = moment(item?.sessionEnd).format("YYYY");
    let testerMonth = moment(item?.sessionEnd).format("MM");
    let testerTime = moment(item?.sessionEnd)
      .add(60, "minutes")
      .format("h:mma");
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentDate = moment().format("DD-MM-YYYY");
    let sessionDate = moment(item?.sessionStart).format("DD-MM-YYYY");
    let sessionTime = moment(item?.sessionStart);
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    if (
      testerYear > currentYear ||
      (testerYear == currentYear && testerMonth > currentMonth)
    ) {
      return false;
    } else if (currentMonth == testerMonth) {
      if (presentDate > sessionDate) {
        return false;
      } else if (presentDate > sessionDate) {
        return true;
      } else if (sessionDate === presentDate) {
        if (endTime <= presentTime) {
          return true;
        } else {
          return false;
        }
      } else if (presentDate < sessionDate) {
        return false;
      } else {
        return false;
      }
    } else if (testerYear == currentYear && testerMonth < currentMonth) {
      return true;
    } else if (currentYear > testerYear) {
      return true;
    }
  };
  const testCalendarColor = (item) => {
    let presentTime = moment().format("YYYY-MM-DD HH:mm A");
    let sessionEndTime = moment(item?.sessionEnd).format("YYYY-MM-DD HH:mm A");
    let endTime = moment(sessionEndTime, "YYYY-MM-DD HH:mm A")
      .add(60, "minutes")
      .format("YYYY-MM-DD HH:mm A");
    let testerYear = moment(item?.sessionEnd).format("YYYY");
    let testerMonth = moment(item?.sessionEnd).format("MM");
    let testerTime = moment(item?.sessionEnd)
      .add(60, "minutes")
      .format("h:mma");
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentDate = moment().format("DD-MM-YYYY");
    let sessionDate = moment(item?.sessionStart).format("DD-MM-YYYY");
    let sessionTime = moment(item?.sessionStart);
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");

    if (currentMonth == testerMonth && currentYear == testerYear) {
      if (presentDate > sessionDate) {
        return true;
      } else if (sessionDate === presentDate) {
        if (endTime <= presentTime) {
          return true;
        } else {
          return false;
        }
      } else if (presentDate < sessionDate) {
        return false;
      } else {
        return false;
      }
    } else
      return (
        new Date(moment(item?.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ")) <
        new Date()
      );
  };
  const newArrayCalendar = [];
  const newArrayCalendar2 = [];
  eventdata2?.map((item, index) => {
    let testerRecording =
      item?.recordings !== undefined &&
      item?.recordings !== null &&
      item?.recordings !== "" &&
      item?.recordings?.length > 0;
    let param = {
      id: item.cohortGroupSessionId,
      startAt: moment(item.sessionStartDate).format("YYYY-MM-DDThh:mm:ssZ"),
      endAt: moment(item.sessionEndDate).format("YYYY-MM-DDThh:mm:ssZ"),
      timezoneStartAt: "", // optional
      // summary: `${moment(item.sessionTime, "hh:mm").format("hh:mma")} Session ${
      //   index + 1
      // }`,
      summary: `${testerRecording ? "*" : ""} ${moment(
        item.sessionTime,
        "hh:mm"
      ).format("hh:mma")}-${moment(item.sessionEndDate).format("hh:mma")}`,
      summary2: `Session No. ${index + 1}`,
      color:
        item.sessionStatus === "COMPLETED"
          ? "#92a9b0"
          : item?.sessionStatus == "CANCELLED"
          ? "#d07979"
          : item.sessionStatus === "CLOSED"
          ? "#7784d8"
          : (item?.sessionStatus !== "COMPLETED" ||
              item?.sessionStatus == "CANCELLED") &&
            testCalendarColor(item)
          ? "#7784d8"
          : "#b499c7",
      sessionData: item,
      calendarID: "work",
    };
    if (calendarStatus !== "") {
      if (calendarStatus == item?.sessionStatus) newArrayCalendar2.push(param);
    } else {
      if (loggedIn == null || loggedIn == "" || loggedIn == undefined) {
        if (param?.sessionData?.sessionStatus == "SCHEDULED")
          newArrayCalendar2.push(param);
      } else newArrayCalendar2.push(param);
      // let newArr =newArrayCalendar2
      // setCalendarInitial(newArr)
    }
  });
  calendardata?.map((item, index) => {
    let testerRecording =
      item?.recordings !== undefined &&
      item?.recordings !== null &&
      item?.recordings !== "" &&
      item?.recordings?.length > 0;
    // let beforetime1 = moment(item.sessionStart).format("DD-MM-YYYY HH:mm A").subtract(5,"minutes").format("DD-MM-YYYY HH:mm A");
    let param = {
      id: item.scheduleId,
      startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
      endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
      // startAt: "2022-08-06T18:00:00.000Z",
      // endAt: "2022-08-06T19:00:00.000Z",
      timezoneStartAt: "", // optional
      // summary: `${item.title.substring(0, 10)}...`,
      // summary: `${moment(item.sessionTime, "hh:mm").format("hh:mma")} Session ${
      //   index + 1
      // }`,
      summary: `${testerRecording ? "*" : ""} ${moment(
        item.sessionTime,
        "hh:mm"
      ).format("hh:mma")}-${moment(item.sessionEnd).format("hh:mma")}`,

      summary2: `Session No. ${index + 1}`,
      color:
        // new Date(item.filterEndDate) < new Date() ? "#6aa3b2" : "#dbb63f",
        item.sessionStatus === "COMPLETED"
          ? "#92a9b0"
          : item.sessionStatus === "CLOSED"
          ? "#7784d8"
          : item?.sessionStatus == "CANCELLED"
          ? // ? "#f86880"
            // "#f0516c"
            // "#f65555"
            "#d07979"
          : // : item.sessionStatus === "SCHEDULED" &&
          //   new Date(moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ")) <
          //     new Date() &&
          //   moment(item.sessionEnd).format("hh:mma") <
          //     moment(new Date()).format("hh:mma")
          // ? "#7784d8"
          // : item.sessionStatus === "SCHEDULED" &&
          //   moment(item.sessionEnd)
          //     .format("YYYY-MM-DDThh:mm:ssZ")
          //     .toString()
          //     .slice(0, 10) ===
          //     moment(new Date())
          //       .format("YYYY-MM-DDThh:mm:ssZ")
          //       .toString()
          //       .slice(0, 10) &&
          //   moment(item.sessionEnd).format("hh:mma") >
          //     moment(new Date()).format("hh:mma")
          // ? "#b499c7"
          // : item.sessionStatus === "SCHEDULED" &&
          //   new Date(moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ")) >
          //     new Date() &&
          //   moment(item.sessionEnd).format("hh:mma") >
          //     moment(new Date()).format("hh:mma")
          // ? "#b499c7"
          // item?.sessionStatus == "SCHEDULED" &&

          (item?.sessionStatus !== "COMPLETED" ||
              item?.sessionStatus == "CANCELLED") &&
            testCalendarColor(item)
          ? // endTime < presentTime
            // new Date(moment(item?.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ")) <
            //     new Date()
            "#7784d8"
          : "#b499c7",
      // new Date(newfilteredDate) < new Date() ?
      sessionData: item,
      calendarID: "work",
    };
    if (calendarStatus !== "") {
      if (calendarStatus == item?.sessionStatus) newArrayCalendar.push(param);
    } else {
      let testBoolean =
        showCohortsOnly !== undefined &&
        showCohortsOnly &&
        item?.sessionType == "cohortSession"
          ? true
          : false;
      // if (testBoolean)
      if(!showCohortsOnly)
      {
        newArrayCalendar.push(param);
      }
      else {
        if (item?.sessionType == "cohortSession")
        newArrayCalendar.push(param);
        //  newArr2.push(param);
      }
      //  newArrayCalendar.push(param);
    }
    // newArrayCalendar.push(param);
  });

  // const events = [
  //   {
  //     id: 1,
  //     // startAt: "2022-08-06T18:00:00.000Z",
  //     // endAt: "2022-08-06T19:00:00.000Z",
  //     startAt: moment(calendardata[0]?.sessionStart).format(
  //       "YYYY-MM-DDThh:mm:ssZ"
  //     ),
  //     endAt: moment(calendardata[0]?.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
  //     timezoneStartAt: "UTC", // optional
  //     summary: "test",
  //     color:
  //       new Date(
  //         moment(calendardata[0]?.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ")
  //       ) < new Date()
  //         ? "#92a9b0"
  //         : "#b499c7",
  //     calendarID: "work",
  //   },
  //   {
  //     id: 2,
  //     startAt: "2022-08-18T20:00:00.000Z",
  //     endAt: "2022-08-18T21:00:00.000Z",
  //     // startAt: moment(calendardata[1]?.sessionStart).format(
  //     //   "YYYY-MM-DDThh:mm:ssZ"
  //     // ),
  //     // endAt: moment(calendardata[1]?.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
  //     timezoneStartAt: "UTC", // optional
  //     summary: "test",
  //     color:
  //       new Date("2022-08-18T21:00:00.000Z") < new Date()
  //         ? "#92a9b0"
  //         : "#b499c7",
  //   },
  // ];

  // useEffect(() => {
  //   calendardata?.data?.map((item, index) => {
  //     let param = {
  //       id: index + 1,
  //       startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
  //       endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
  //       // startAt: "2022-08-06T18:00:00.000Z",
  //       // endAt: "2022-08-06T19:00:00.000Z",
  //       timezoneStartAt: "UTC", // optional
  //       // summary: `${item.title.substring(0, 10)}...`,
  //       summary: `new`,
  //       color:
  //         // new Date(item.filterEndDate) < new Date() ? "#6aa3b2" : "#dbb63f",
  //         new Date(item.sessionEnd) < new Date() ? "#92a9b0" : "#4ce070",
  //       // new Date(newfilteredDate) < new Date() ?

  //       calendarID: "work",
  //     };
  //     activityArray.push(param);
  //     // setActivityArray({ ...activityArray, param });
  //     // setActivityArray((currentArray) => [...currentArray, param]);

  //     // setnewfilteredDate(item.filterEndDate);
  //   });
  // }, [calendardata]);

  const handleFilterChanges = () => {
    const newsubArray = [];
    const newsubSpecialArray = [];
    let value = localStorage.getItem("SavedLoggedInData");
    let LoginData = JSON.parse(value);
    formData?.subindustry.map((stage) => {
      newsubArray.push(stage.value);
    });
    setFilterData2(newsubArray);
    SetErrorVisible2(false);
    formData?.subspecialization.map((stage) => {
      newsubSpecialArray.push(stage.value);
      setFilterData4(newsubSpecialArray);
      SetErrorVisible4(false);
    });
    if (
      filterData !== undefined &&
      filterData !== "select" &&
      filterData3 !== undefined &&
      filterData3 !== "select" &&
      filterData5 !== undefined &&
      filterData5 !== "select" &&
      (filterData2?.length > 0 || filterData4?.length > 0) &&
      (props.fromModule !== null &&
      props.fromModule !== undefined &&
      props.fromModule === "allMentorsList"
        ? filterData7 !== undefined
        : true)
    ) {
      if (
        (filterData2?.length > 0 && filterData4?.length > 0) ||
        filterData2?.length == 10 ||
        filterData4?.length == 10
      ) {
        let output = {
          industry: filterData === undefined ? "" : filterData,
          function: filterData3 === undefined ? "" : filterData3,
          sub_industry: newsubArray === undefined ? "" : newsubArray,
          sub_function:
            newsubSpecialArray === undefined ? "" : newsubSpecialArray,
          stage: filterData5 === undefined ? "" : filterData5,
          purpose:
            props.fromModule !== null &&
            props.fromModule !== undefined &&
            props.fromModule === "allMentorsList"
              ? filterData7
              : "",
          state: filterData6 === undefined ? "" : filterData6,
          requestedBy: LoginData.id,
          mentorId: props.mentorID !== undefined ? props.mentorID : "",
        };
        api
          .POST(ALL_STARTUP_SEARCH_REQUEST_SUBMIT_NEW, output)
          .then((response) => {
            const { status, data } = response;
            if (status === 200) {
              // alert("Success")
              props.sendToParent(output);
              props.setModalVisibility(false);
              setFormData(defaultFormData2);
              swal({
                title: "Thank You",
                text: `Request Submitted Successfully`,
                icon: "success",
                // timer: 1500,
                // buttons: false,
              }).then(function () {
                localStorage.setItem("myRequests", "myRequests");
                window.location.reload();
              });
            }
          });
      } else {
        if (filterData2.length > 0 || filterData4.length == 10)
          SetErrorVisible2(false);
        else SetErrorVisible2(true);
        if (filterData4.length > 0 || filterData2.length == 10)
          SetErrorVisible4(false);
        else SetErrorVisible4(true);
      }
    } else {
      let output = {
        industry: filterData,
        function: filterData3,
        sub_industry: newsubArray,
        sub_function: newsubSpecialArray,
        stage: filterData5,
        state: filterData6,
        purpose: filterData7,
        requestedBy: LoginData.id,
      };
      if (filterData === undefined || filterData == "select")
        SetErrorVisible(true);
      else SetErrorVisible(false);
      if (filterData2.length > 0 || filterData4.length == 10)
        SetErrorVisible2(false);
      else SetErrorVisible2(true);

      if (filterData3 === undefined || filterData3 == "select")
        SetErrorVisible3(true);
      else SetErrorVisible3(false);
      if (filterData4.length > 0 || filterData2.length == 10)
        SetErrorVisible4(false);
      else SetErrorVisible4(true);
      if (filterData5 === undefined || filterData5 == "select")
        SetErrorVisible5(true);
      else SetErrorVisible5(false);
      if (filterData7 === undefined) SetErrorVisible7(true);
      else if (
        testWordLimit(filterData7) > 0 &&
        testWordLimit(filterData7) < 101
      ) {
        SetErrorVisible7(false);
      }
      // setError(true);
    }
  };
  const handleClose = () => {
    props.setModalVisibility(false);
  };

  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };

  useEffect(() => {
    // axios({
    //   // url: GET_NAMES_DATA,
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       loggedIn?.id,
    //     listKey: "Mentor",
    //   },
    // })
    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId: localStorage.getItem("SavedLoggedInData") && loggedIn?.id,
        listKey: "Mentor",
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       loggedIn?.id,
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId: localStorage.getItem("SavedLoggedInData") && loggedIn?.id,
        listKey: "Startup",
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  }, []);
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 100) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 100 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    }
    return value;
  };

  const onPageChange = (data) => {
    localStorage.setItem("rangeData", JSON.stringify(data));
    // setRangeTo(data.rangeTo);
    setRangeTo(
      data.rangeTo
      // new Date(data.rangeTo)
      //   .toISOString()
      //   .split("T")[0]
      //   .split("-")
      //   .reverse()
      //   .join("-")
    );
    // setRangeFrom(data.rangeFrom);
    setRangeFrom(
      data.rangeFrom
      // new Date(data.rangeFrom)
      //   .toISOString()
      //   .split("T")[0]
      //   .split("-")
      //   .reverse()
      //   .join("-")
    );
    // if (
    //   props?.allCalendarData !== undefined &&
    //   props?.allCalendarData !== null &&
    //   props?.allCalendarData !== "" &&
    //   props?.allCalendarData
    // ) {
    filterBtnClicked("");
    // }
  };

  const cohortgroupsessionfunc = (scheduleid) => {
    // axios({
    //   // url: GET_NAMES_DATA,
    //   url: GET_DETAILS_COHORT_GROUP_SESSION,
    //   method: "POST",
    //   data: {
    //     cohortGroupSessionId: scheduleid,
    //   },
    // })
    api
      .POST(GET_DETAILS_COHORT_GROUP_SESSION, {
        cohortGroupSessionId: scheduleid,
        userId: loggedIn?.id,
      })
      .then((res) => {
        setGroupsessiondata(res.data?.data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    const rangedata = JSON.parse(localStorage.getItem("rangeData"));
    setIntialDateRange(rangedata);
    // axios({
    //   url: SESSION_CALENDAR,
    //   method: "POST",
    //   data: {
    //     userId: loggedIn?.id,
    //     sessionStatus: "",
    //     // startDate: startOfMonth,
    //     startDate: rangedata?.rangeFrom,
    //     // endDate: endOfMonth,
    //     endDate: rangedata?.rangeTo,
    //   },
    // })
    api
      .POST(SESSION_CALENDAR, {
        userId: loggedIn?.id,
        sessionStatus: "",
        // startDate: startOfMonth,
        startDate: rangedata?.rangeFrom,
        // endDate: endOfMonth,
        endDate: rangedata?.rangeTo,
      })
      .then((res) => {
        setCalendardata(res.data?.data);
        // props.closeLoader()
      })
      .catch((err) => {});
  }, [sessionModalOpen]);
  useEffect(() => {
    if (loggedIn?.role === "Mentor")
      // axios({
      //   url: MY_MENTORSHIP_LIST,
      //   method: "POST",
      //   data: {
      //     mentorId: loggedIn?.id,
      //     status: "ACTIVE",
      //   },
      // })
      api
        .POST(MY_MENTORSHIP_LIST, {
          mentorId: loggedIn?.id,
          status: "ACTIVE",
        })
        .then((res) => {
          // setData(res.data?.data);
          let data = res.data.data;
          if (data !== undefined && data !== null && data?.length > 0) {
            let obj;
            let arr = [];
            data.map((item, index) => {
              obj = {
                label: item?.startup.organization_name,
                value: item?.startup.id,
                mentorshipId: item?.id,
              };
              arr.push(obj);
            });
            setData(arr);
          }
          // props.closeLoader();
        })
        .catch((err) => {
          // props.closeLoader();
        });
    else {
      // axios({
      //   url: MY_MENTORSHIP_LIST,
      //   method: "POST",
      //   data: {
      //     requestedBy: loggedIn?.id,
      //     status: "ACTIVE",
      //   },
      // })
      api
        .POST(MY_MENTORSHIP_LIST, {
          requestedBy: loggedIn?.id,
          status: "ACTIVE",
        })
        .then((res) => {
          // setData(res.data?.data);
          let data = res.data.data;
          if (data !== undefined && data !== null && data?.length > 0) {
            let obj;
            let arr = [];
            data.map((item, index) => {
              obj = {
                label: item?.mentorRequest?.mentorName,
                value: item?.mentorRequest?.mentorId,
                mentorshipId: item?.id,
              };
              arr.push(obj);
            });
            setData(arr);
          }
          // if (data !== undefined && data !== null && data?.length > 0) {
          //   let obj;
          //   let arr = [];
          //   data.map((item, index) => {
          //     obj = {
          //       label: item?.mentorRequest.mentorName,
          //       value: item?.mentorRequest.mentorId,
          //       mentorshipId: item?.id,
          //     };
          //     arr.push(arr);
          //   });
          //   console.log("first",arr)
          //   console.log("came here")
          //   setData(arr);
          // }
          // props.closeLoader();
        })
        .catch((err) => {
          // props.closeLoader();
        });
    }
  }, []);

  useEffect(() => {
    let params = {
      cohortId: "",
      cohortAdminId: loggedIn?.id,
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: "",
      function: "",
      stage: "",
      searchField: loggedIn?.id,
      searchKey: null,
      status: "VERIFIED",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  }, []);
  useEffect(() => {
    if (reloadCalendar) {
      // axios({
      //   url: SESSION_CALENDAR,
      //   method: "POST",
      //   data: {
      //     userId: loggedIn?.id,
      //     sessionStatus: "",
      //     // startDate: startOfMonth,
      //     startDate: rangedata?.rangeFrom,
      //     // endDate: endOfMonth,
      //     endDate: rangedata?.rangeTo,
      //   },
      // })
      setTimeout(() => {
        if (
          props?.allCalendarData !== undefined &&
          props?.allCalendarData !== null &&
          props?.allCalendarData !== "" &&
          props?.allCalendarData
        ) {
          const rangedata = JSON.parse(localStorage.getItem("rangeData"));
          let params;
          if (
            props?.allCalendarData !== undefined &&
            props?.allCalendarData !== null &&
            props?.allCalendarData !== ""
          ) {
            params = {
              sessionStartDate:
                rangedata?.rangeFrom !== null
                  ? rangedata?.rangeFrom
                  : "2023-08-01T18:00:00.000Z",
              sessionEndDate:
                rangedata?.rangeTo !== null
                  ? rangedata?.rangeTo
                  : "2023-08-31T18:00:00.000Z",
              cohortId: props?.particularCohort,
            };
          } else {
            params = {
              sessionStartDate:
                rangedata?.rangeFrom !== null
                  ? rangedata?.rangeFrom
                  : "2023-08-01T18:00:00.000Z",
              sessionEndDate:
                rangedata?.rangeTo !== null
                  ? rangedata?.rangeTo
                  : "2023-08-31T18:00:00.000Z",
            };
          }
          api
            .POST(ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR, params)
            .then((res) => {
              // setCalendardata(res.data?.data);
              setEventdata2(res.data?.data);
            })
            .catch((err) => {});
        } else {
          const rangedata = JSON.parse(localStorage.getItem("rangeData"));
          api
            .POST(SESSION_CALENDAR, {
              userId: loggedIn?.id,
              sessionStatus: "",
              // startDate: startOfMonth,
              startDate: rangedata?.rangeFrom,
              // endDate: endOfMonth,
              endDate: rangedata?.rangeTo,
            })
            .then((res) => {
              setCalendardata(res.data?.data);
              // props.closeLoader()
            })
            .catch((err) => {});
        }
      }, 1750);
    }

    setTimeout(() => {
      setReloadCalendar(false);
    }, 4000);
  }, [reloadCalendar]);
  // useEffect(() => {
  //   if(newArrayCalendar2?.length > 0)
  //   {

  //   }
  // }, [newArrayCalendar2])
  useEffect(() => {
    setCalendarStatus("");
    setRangeTo();
    setRangeFrom();
    // setAllCalendarDataArr([]);
    // setEventdata2("");
    // setReloadCalendar(false)
  }, []);
  const filterBtnClicked = (status) => {
    // setCalendarStatus(status)
    if (status == "ALL") {
      setAllCalendarDataArr(calendarInitial);
      setCalendarStatus("");
    } else {
      setCalendarStatus(status);
      if (props?.allCalendarData) {
        let arr = [];
        eventdata2?.map((item, index) => {
          let testerRecording =
            item?.recordings !== undefined &&
            item?.recordings !== null &&
            item?.recordings !== "" &&
            item?.recordings?.length > 0;
          let param = {
            id: item.cohortGroupSessionId,
            startAt: moment(item.sessionStartDate).format(
              "YYYY-MM-DDThh:mm:ssZ"
            ),
            endAt: moment(item.sessionEndDate).format("YYYY-MM-DDThh:mm:ssZ"),
            timezoneStartAt: "",
            summary: `${testerRecording ? "*" : ""} ${moment(
              item.sessionTime,
              "hh:mm"
            ).format("hh:mma")}-${moment(item.sessionEndDate).format(
              "hh:mma"
            )}`,
            summary2: `Session No. ${index + 1}`,
            color:
              item.sessionStatus === "COMPLETED"
                ? "#92a9b0"
                : item?.sessionStatus == "CANCELLED"
                ? "#d07979"
                : item.sessionStatus === "CLOSED"
                ? "#7784d8"
                : (item?.sessionStatus !== "COMPLETED" ||
                    item?.sessionStatus == "CANCELLED") &&
                  testCalendarColor(item)
                ? "#7784d8"
                : "#b499c7",
            sessionData: item,
            calendarID: "work",
          };
          if (item.sessionStatus == status)
          {
            if(!showCohortsOnly)
          {
            arr.push(param);
          }
          else {
            if (item?.sessionType == "cohortSession")
            arr.push(param);
            //  newArr2.push(param);
          }
          }
          //  arr.push(param);
        });
        setAllCalendarDataArr(arr);
      } else {
        let arr = [];
        calendardata?.map((item, index) => {
          let testerRecording =
            item?.recordings !== undefined &&
            item?.recordings !== null &&
            item?.recordings !== "" &&
            item?.recordings?.length > 0;
          let param = {
            id: item.scheduleId,
            startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
            endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
            timezoneStartAt: "", // optional
            summary: `${testerRecording ? "*" : ""} ${moment(
              item.sessionTime,
              "hh:mm"
            ).format("hh:mma")}-${moment(item.sessionEnd).format("hh:mma")}`,
            summary2: `Session No. ${index + 1}`,
            color:
              item.sessionStatus === "COMPLETED"
                ? "#92a9b0"
                : item?.sessionStatus == "CANCELLED"
                ? "#d07979"
                : item.sessionStatus === "CLOSED"
                ? "#7784d8"
                : (item?.sessionStatus !== "COMPLETED" ||
                    item?.sessionStatus == "CANCELLED") &&
                  testCalendarColor(item)
                ? "#7784d8"
                : "#b499c7",
            sessionData: item,
            calendarID: "work",
          };
          if (item.sessionStatus == status) 
          {
            if(!showCohortsOnly)
          {
            arr.push(param);
          }
          else {
            if (item?.sessionType == "cohortSession")
            arr.push(param);
            //  newArr2.push(param);
          }
          }
          // arr.push(param);
        });
        setAllCalendarDataArr(arr);
      }
    }
  };
  useEffect(() => {
    let newArr = [];
    if (eventdata2?.length > 0 && props?.allCalendarData) {
      eventdata2?.map((item, index) => {
        let testerRecording =
          item?.recordings !== undefined &&
          item?.recordings !== null &&
          item?.recordings !== "" &&
          item?.recordings?.length > 0;
        let param = {
          id: item.cohortGroupSessionId,
          startAt: moment(item.sessionStartDate).format("YYYY-MM-DDThh:mm:ssZ"),
          endAt: moment(item.sessionEndDate).format("YYYY-MM-DDThh:mm:ssZ"),
          timezoneStartAt: "", // optional
          // summary: `${moment(item.sessionTime, "hh:mm").format("hh:mma")} Session ${
          //   index + 1
          // }`,
          summary: `${testerRecording ? "*" : ""} ${moment(
            item.sessionTime,
            "hh:mm"
          ).format("hh:mma")}-${moment(item.sessionEndDate).format("hh:mma")}`,
          summary2: `Session No. ${index + 1}`,
          color:
            item.sessionStatus === "COMPLETED"
              ? "#92a9b0"
              : item?.sessionStatus == "CANCELLED"
              ? "#d07979"
              : item.sessionStatus === "CLOSED"
              ? "#7784d8"
              : (item?.sessionStatus !== "COMPLETED" ||
                  item?.sessionStatus == "CANCELLED") &&
                testCalendarColor(item)
              ? "#7784d8"
              : "#b499c7",
          sessionData: item,
          calendarID: "work",
        };
        newArr.push(param);
      });
      setCalendarInitial(newArr);
    }
  }, [eventdata2]);
  useEffect(() => {
    modifyCalendarData();
  }, [calendardata]);
  const modifyCalendarData = () => {
    let newArr2 = [];
    if (calendardata?.length > 0 && !props?.allCalendarData) {
      calendardata?.map((item, index) => {
        let testerRecording =
          item?.recordings !== undefined &&
          item?.recordings !== null &&
          item?.recordings !== "" &&
          item?.recordings?.length > 0;
        let param = {
          id: item.scheduleId,
          startAt: moment(item.sessionStart).format("YYYY-MM-DDThh:mm:ssZ"),
          endAt: moment(item.sessionEnd).format("YYYY-MM-DDThh:mm:ssZ"),
          timezoneStartAt: "", // optional
          summary: `${testerRecording ? "*" : ""} ${moment(
            item.sessionTime,
            "hh:mm"
          ).format("hh:mma")}-${moment(item.sessionEnd).format("hh:mma")}`,
          summary2: `Session No. ${index + 1}`,
          color:
            item.sessionStatus === "COMPLETED"
              ? "#92a9b0"
              : item?.sessionStatus == "CANCELLED"
              ? "#d07979"
              : item.sessionStatus === "CLOSED"
              ? "#7784d8"
              : (item?.sessionStatus !== "COMPLETED" ||
                  item?.sessionStatus == "CANCELLED") &&
                testCalendarColor(item)
              ? "#7784d8"
              : "#b499c7",
          sessionData: item,
          calendarID: "work",
        };
        let filterBoolean =
          (filterCohortId !== undefined && filterCohortId !== "" && filterCohortId !== null )
            ? filterCohortId == item?.id
            : true;
        // let testBoolean =
        //   showCohortsOnly !== undefined &&
        //   showCohortsOnly &&
        //   item?.sessionType == "cohortSession"
        //     ? true
        //     : false;
        if(!showCohortsOnly && filterBoolean)
        {
          newArr2.push(param);
        }
        else {
          if (item?.sessionType == "cohortSession" && filterBoolean) newArr2.push(param);
        }
      });
      setCalendarInitial(newArr2);
    }
  };
  useEffect(() => {
    modifyCalendarData();
  }, [filterCohortId]);
  
  return (
    <>
      {sessionModalOpen && (
        <SessionsModal2
          modalVisibility={sessionModalOpen}
          setModalVisibility={setSessionModalOpen}
          type="sessiondetail"
          sessiondata={eventdata}
          groupsessiondata={groupsessiondata}
          reloadCalendar={setReloadCalendar}
          reloadCalendarData={calendardata}
          allCalendarData={props?.allCalendarData}
          // parentData={""}
          // modalData={sessionModalData}
          // setModalOpen={setModalOpen}
          // openEditModal={setEditModalVisibility}
          // parentData={setSessionModalChild}
        />
      )}
      {scheduleModalOpen && (
        <ModalVisible
          modalOpen={scheduleModalOpen}
          allMentorList={allMentorList}
          allStartupList={allStartupList}
          // mentorshipId={params.mentorshipId}
          setModalOpen={setScheduleModalOpen}
          onBroadcastSelectionChange={onBroadcastSelectionChange}
          setTaggingList={setTaggingList}
          taggingList={taggingList}
          parentData={setReloadCalendar}
          fromPage={"Calendar"}
          EditModalValue={false}
          // refreshPage={setRefreshPage}
        />
      )}

      {scheduleModalOpen2 === true && (
        <CalendarCreateSession
          modalOpen={scheduleModalOpen2}
          setModalOpen={setScheduleModalOpen2}
          sessionList={data}
          EditModalValue={false}
          parentData={setReloadCalendar}
        />
      )}

      <Modal
        size="lg"
        show={props.modalVisibility}
        onHide={() => props.setModalVisibility(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        // style={{ borderRadius: "7px", border: "1px black solid" }}
        className="sessionnewmodal"
      >
        <Modal.Header className="d-flex">
          <Modal.Title className="modalHeading mysessioncalendarhead">
            {props?.allCalendarData !== undefined &&
            props?.allCalendarData !== null &&
            props?.allCalendarData !== "" &&
            props?.allCalendarData
              ? "COHORTS EVENTS CALENDAR"
              : "MY SESSIONS"}
          </Modal.Title>
          <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
            <span
              className="tooltiptext  close-window"
              style={{ left: "-115px", top: "2px", width: "118px" }}
            >
              Close Window
            </span>
          </div>
        </Modal.Header>
        {/* {props?.showCohortsOnly && (
          <div className="mt-2" style={{ marginLeft: "1rem" }}>
            <Select
              required={true}
              id="cohortorgname"
              variant="outlined"
              fullWidth
              margin="normal"
              name="cohortorgname"
              className="col-12 gendermentorinput"
              styles={customStyles}
              value={formData.cohortorgname}
              onChange={(e) => {
                setFormData((user) => {
                  return {
                    ...user,
                    cohortorgname: e.value == "select" ? null : e,
                    cohortId: null,
                  };
                });
                setFilterCohortId(e.value);
                if (e.value === "select" || e.value === "Select")
                  setSearchCohortId("");
                else setSearchCohortId(e.value);
              }}
              options={cohortnameList}
              placeholder="Cohort Name"
            />
          </div>
        )} */}
          {data &&
                  data !== null &&
                  data !== "" &&
                  data?.length > 0 &&
                  loggedIn?.role == "Startup" && !showCohortsOnly ? (
                    <div
                      className="d-flex"
                      style={{
                        flexDirection: "row",
                        width: "100%",
                        justifyContent:"center"
                        // paddingLeft: "10%",
                      }}
                    >
                      <div
                        className="dashboard-blue-btn top-btn newuserTooltip schdlesessionbtndivnow"
                        style={{
                          maxWidth: "331px",
                          cursor: "default",
                          // marginRight: "1rem",
                          bottom: "1rem",
                          left: "2rem",
                        }}
                        onClick={() => setScheduleModalOpen2(true)}
                      >
                        <a
                          className="blue-link-dashboard"
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                            // fontSize: "18px",
                            // left: "4.75rem",
                            // top: "-1px",
                            position: "relative",
                            fontSize: "16px",
                            left: "5rem",
                            top: "-8px",
                          }}
                        >
                          {" "}
                          SCHEDULE SESSION
                        </a>
                        <span
                          className="tooltiptext  tooltip-bottom"
                          style={{
                            width: "250px !important",
                            position: "absolute",
                            left: "6rem",
                            top: "4rem",
                          }}
                        >
                          Schedule Session
                        </span>
                      </div>
                      {/* <div
                        className="dashboard-bottom-btn top-btn  newuserTooltip createcohortsessionbtn"
                        style={{
                          maxWidth: "331px",
                          cursor: "default",
                          top: "0.25rem",
                          right: "4rem",
                          // marginRight: "1rem",
                          bottom: "0rem",
                        }}
                        onClick={() => {
                          localStorage.setItem(
                            "sessionRecording",
                            "sessionRecording"
                          );
                          window.location.reload();
                        }}
                      >
                        <a
                          className="text-white3 createcohortsessionbtnpara"
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                            // fontSize: "18px",
                            // left: "4.75rem",
                            // top: "-1px",
                            position: "relative",
                            fontSize: "16px",
                            left: "5rem",
                            top: "-2px",
                          }}
                        >
                          {" "}
                          SESSION RECORDINGS
                        </a>
                        <span
                          className="tooltiptext  tooltip-bottom"
                          style={{
                            width: "250px !important",
                            position: "absolute",
                            left: "6rem",
                            top: "4rem",
                          }}
                        >
                          Click to View Session Recordings
                        </span>
                      </div> */}
                    </div>
                  ) : (
                    ""
                  )}
        <div className="sessionmodalbody mt-1">
          <div
            style={{
              margin: "0rem",
              // display: "flex",
            }}
            className="mysssnbtnsbothdiv sessionmodalbodybutton09 "
          >
            {props?.allCalendarData !== undefined &&
              props?.allCalendarData !== null &&
              props?.allCalendarData !== "" &&
              !props?.allCalendarData && 
              loggedIn?.role !== "Admin" && (
                <>
                  {loggedIn?.role !== "Admin" &&
                  loggedIn?.role !== "Startup" &&
                  cohortMentorData &&
                  cohortMentorData?.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        paddingLeft: "2%",
                        justifyContent:"center"
                      }}
                    >
                      {/* <div
                className="dashboard-bottom-btn top-btn  newuserTooltip createcohortsessionbtn"
                onClick={() => setScheduleModalOpen(true)}
                style={{width:"33%"}}
              >
                <p
                  style={{ cursor: "pointer" }}
                  className="text-white32 chrtsesionheadlinepara"
                >
                  CREATE COHORT SESSION
                </p>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{ left: "130px", top: "60px", width: "220px" }}
                >
                  Click to Create a Cohort Session
                </span>
              </div> */}
                      <div
                        className="dashboard-bottom-btn top-btn newuserTooltip"
                        style={{
                          left: "0.25rem",
                          width: "31%",
                          maxWidth: "33%",                          // marginRight: "1rem",
                          bottom: "-0.25rem",
                        }}
                        onClick={() => {
                          setScheduleModalOpen(true);
                        }}
                      >
                        <a
                          className="text-white3 createcohortsessionbtnpara"
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                            // fontSize: "18px",
                            // left: "4.75rem",
                            // top: "-1px",
                            position: "relative",
                            fontSize: "14px",
                            left: "2.85rem",
                            top: "-26px",
                          }}
                        >
                          {" "}
                          CREATE COHORT SESSION
                        </a>
                        <span
                          className="tooltiptext  tooltip-bottom"
                          style={{
                            width: "230px !important",
                            position: "absolute",
                            left: "5rem",
                            top: "3.5rem",
                          }}
                        >
                          Click to Create a Cohort Session
                        </span>
                      </div>
                     {
                      !showCohortsOnly &&
                      <div
                        className="dashboard-blue-btn top-btn newuserTooltip"
                        style={{
                          cursor: "default",
                          // marginRight: "1rem",
                          bottom: "1.05rem",
                          left: "0.3rem",
                          width: "31%",
                          maxWidth: "33%",
                        }}
                        onClick={() => setScheduleModalOpen2(true)}
                      >
                        <a
                          className=""
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                            // fontSize: "18px",
                            // left: "4.75rem",
                            // top: "-1px",
                            position: "relative",
                            fontSize: "14px",
                            left: "4.5rem",
                            top: "-15px",
                          }}
                        >
                          {" "}
                          SCHEDULE SESSION
                        </a>
                        <span
                          className="tooltiptext  tooltip-bottom"
                          style={{
                            width: "185px !important",
                            position: "absolute",
                            left: "6rem",
                            top: "3.5rem",
                          }}
                        >
                          Schedule Session
                        </span>
                      </div>}
                      {/* <div
                        className="dashboard-bottom-btn top-btn  newuserTooltip"
                        style={{
                          cursor: "default",
                          top: "0.29rem",
                          width: "31%",
                          maxWidth: "33%",
                          left: "0.75rem",
                          // marginRight: "1rem",
                          bottom: "0rem",
                        }}
                        onClick={() => {
                          localStorage.setItem(
                            "sessionRecording",
                            "sessionRecording"
                          );
                          window.location.reload();
                        }}
                      >
                        <a
                          className="text-white3 createcohortsessionbtnpara"
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                            // fontSize: "18px",
                            // left: "4.75rem",
                            // top: "-1px",
                            position: "relative",
                            fontSize: "14px",
                            left: "3.75rem",
                            top: "-6px",
                          }}
                        >
                          {" "}
                          SESSION RECORDINGS
                        </a>
                        <span
                          className="tooltiptext  tooltip-bottom"
                          style={{
                            width: "240px !important",
                            position: "absolute",
                            left: "4rem",
                            top: "3.5rem",
                          }}
                        >
                          Click to View Session Recordings
                        </span>
                      </div> */}
                    </div>
                  ) : (
                    loggedIn?.role !== "Startup" && (
                      <div
                        className="d-flex"
                        style={{
                          flexDirection: "row",
                          width: "100%",
                          paddingLeft: "10%",
                        }}
                      >
                        <div
                          className="dashboard-blue-btn top-btn newuserTooltip schdlesessionbtndivnow"
                          style={{
                            maxWidth: "331px",
                            cursor: "default",
                            // marginRight: "1rem",
                            bottom: "1rem",
                            left: "2rem",
                          }}
                          onClick={() => setScheduleModalOpen2(true)}
                        >
                          <a
                            className="blue-link-dashboard "
                            style={{
                              paddingRight: "0px",
                              cursor: "pointer",
                              fontWeight: "600",
                              // fontSize: "18px",
                              // left: "4.75rem",
                              // top: "-1px",
                              position: "relative",
                              fontSize: "16px",
                              left: "5rem",
                              top: "-8px",
                            }}
                          >
                            {" "}
                            SCHEDULE SESSION
                          </a>
                          <span
                            className="tooltiptext  tooltip-bottom"
                            style={{
                              width: "250px !important",
                              position: "absolute",
                              left: "6rem",
                              top: "4rem",
                            }}
                          >
                            Schedule Session
                          </span>
                        </div>
                        {/* <div
                          className="dashboard-bottom-btn top-btn  newuserTooltip createcohortsessionbtn"
                          style={{
                            maxWidth: "331px",
                            cursor: "default",
                            top: "0.25rem",
                            right: "4rem",
                            // marginRight: "1rem",
                            bottom: "0rem",
                          }}
                          onClick={() => {
                            localStorage.setItem(
                              "sessionRecording",
                              "sessionRecording"
                            );
                            window.location.reload();
                          }}
                        >
                          <a
                            className="text-white3 createcohortsessionbtnpara"
                            style={{
                              paddingRight: "0px",
                              cursor: "pointer",
                              fontWeight: "600",
                              // fontSize: "18px",
                              // left: "4.75rem",
                              // top: "-1px",
                              position: "relative",
                              fontSize: "16px",
                              left: "5rem",
                              top: "-2px",
                            }}
                          >
                            {" "}
                            SESSION RECORDINGS
                          </a>
                          <span
                            className="tooltiptext  tooltip-bottom"
                            style={{
                              width: "250px !important",
                              position: "absolute",
                              left: "6rem",
                              top: "4rem",
                            }}
                          >
                            Click to View Session Recordings
                          </span>
                        </div> */}
                      </div>
                    )
                  )}
                
                </>
              )}
          </div>
        </div>

        <div className="sessionmodalbody mt-1">
          <div
            style={{
              margin: "0rem",
              // display: "flex",
            }}
            className="mysssnbtnsbothdiv sessionmodalbodybutton09 "
          >
            {props?.allCalendarData !== undefined &&
              props?.allCalendarData !== null &&
              props?.allCalendarData !== "" &&
              props?.allCalendarData && (
                <>
                  {loggedIn?.role !== "Admin" &&
                    loggedIn?.role !== "Startup" &&
                    loggedIn?.role !== null &&
                    loggedIn?.role !== undefined &&
                    cohortMentorData &&
                    cohortMentorData?.length > 0 &&
                    cohortMentorData[cohortMentorData?.length - 1].cohort
                      ?.cohortStatus !== "CLOSED" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          width: "100%",
                          paddingRight: "2%",
                        }}
                      >
                        <div
                          className="dashboard-bottom-btn top-btn newuserTooltip"
                          style={{
                            left: "0.25rem",
                            width: "32%",
                            // marginRight: "1rem",
                            bottom: "-0.25rem",
                          }}
                          onClick={() => {
                            setScheduleModalOpen(true);
                          }}
                        >
                          <a
                            className="text-white3 createcohortsessionbtnpara"
                            style={{
                              paddingRight: "0px",
                              cursor: "pointer",
                              fontWeight: "600",
                              // fontSize: "18px",
                              // left: "4.75rem",
                              // top: "-1px",
                              position: "relative",
                              fontSize: "14px",
                              left: "2.85rem",
                              top: "-15px",
                            }}
                          >
                            {" "}
                            CREATE COHORT SESSION
                          </a>
                          <span
                            className="tooltiptext  tooltip-bottom"
                            style={{
                              width: "230px !important",
                              position: "absolute",
                              left: "5rem",
                              top: "3.5rem",
                            }}
                          >
                            Click to Create a Cohort Session
                          </span>
                        </div>
                      </div>
                    )}
                </>
              )}
          </div>
        </div>

        <Modal.Body style={{ height: "600px" }}>
          {/* <div className="d-flex justify-content-center">
            <div
              className="d-flex mt-2 startupstepsforms"
              style={{ maxWidth: "33rem", flexDirection: "column" }}
            >
              <h6 className="mt-2">Industry (Select 1 Industry) *</h6>
              <MultiselectorComp
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Select Industry"
                options={
                  getPredefineOptions && getPredefineOptions.industry_options
                }
                onChange={(e) => {
                  setFilterData(e.value);
                  SetErrorVisible(false);
                }}
                closeMenuOnSelect={true}
              />
              {errorVisible && (
                <div className="login-error-msg mt-2">
                  {errorMessageIndustry}
                </div>
              )}
              <h6 className="mt-2">
                Industry / Sector - Keywords (Industry/Function Keywords select
                up to 10) *{" "}
              </h6>
              <MultiselectorComp
                options={
                  getPredefineOptions && getPredefineOptions.sub_industry
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Industry/Sector Keywords"
                onChange={(list) =>
                  list.length <= 10 - formData.subspecialization.length
                    ? setFormData((user) => {
                        SetErrorVisible2(false);
                        let arr = list.filter(function (item) {
                          return item.value !== "select";
                        });
                        let newArr = [];
                        arr.forEach((item) => {
                          newArr.push(item.value);
                        });
                        setFilterData2(newArr);
                        if (
                          list.length + formData.subspecialization.length ==
                          10
                        ) {
                          swal({
                            title: "Info!",
                            text: "Maximum 10 keywords limit reached.",
                            icon: "info",
                          });
                        }
                        return { ...user, subindustry: arr };
                      })
                    : null
                }
                value={formData.subindustry}
              />
              {errorVisible2 && (
                <div className="login-error-msg mt-2">
                  {errorMessageIndustryKeywords}
                </div>
              )}
              <h6 className="mt-2">Function (Select 1 Function) *</h6>
              <MultiselectorComp
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                placeholder="Select Function"
                styles={customStyles}
                options={
                  getPredefineOptions && getPredefineOptions._specialisation
                }
                onChange={(e) => {
                  setFilterData3(e.value);
                  SetErrorVisible3(false);
                }}
              />
              {errorVisible3 && (
                <div className="login-error-msg mt-2">
                  {errorMessageFunction}
                </div>
              )}
              <h6 className="mt-2">
                Function - Keywords (Industry/Function Keywords select up to 10)
                *
              </h6>

              <MultiselectorComp
                options={
                  getPredefineOptions && getPredefineOptions.functional_areas
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                placeholder="Function Keywords"
                styles={customStyles}
                onChange={(list) =>
                  list.length <= 10 - formData.subindustry.length
                    ? setFormData((user) => {
                        SetErrorVisible4(false);
                        let arr = list.filter(function (item) {
                          return item.value !== "select";
                        });
                        let newArr = [];
                        arr.forEach((item) => {
                          newArr.push(item.value);
                        });
                        setFilterData4(newArr);
                        if (list.length + formData.subindustry.length == 10) {
                          swal({
                            title: "Info",
                            text: "Maximum 10 keywords limit reached.",
                            icon: "info",
                          });
                        }
                        return { ...user, subspecialization: arr };
                      })
                    : null
                }
                value={formData.subspecialization}
              />
              {errorVisible4 && (
                <div className="login-error-msg mt-2">
                  {errorMessageFunctionKeywords}
                </div>
              )}
              <h6 className="mt-2">
                Current Stage of the Startup (Select 1 Stage) *
              </h6>
              <MultiselectorComp
                hideSelectedOptions={false}
                styles={customStyles}
                placeholder="Select Stage"
                options={
                  getPredefineOptions &&
                  getPredefineOptions.stage_of_startup_options
                }
                onChange={(e) => {
                  setFilterData5(e.value);
                  SetErrorVisible5(false);
                }}
                closeMenuOnSelect={true}
              />
              {errorVisible5 && (
                <div className="login-error-msg mt-2">{errorMessageStage}</div>
              )}
              {props.fromModule !== null &&
                props.fromModule !== undefined &&
                props.fromModule === "allMentorsList" && (
                  <>
                    <h6 className="mt-2">
                      Purpose of Request (max 100 words)*
                    </h6>
                    <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Describe in maximum 100 words"
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white" }}
                      name="purpose"
                      rows={2}
                      InputProps={{ className: classes.input }}
                      // className="purposeBox"
                      maxRows={4}
                      value={filterData7}
                      onChange={(e) => {
                        if (testWordLimit(e.target.value) < 101) {
                          setFilterData7(e.target.value);
                        }
                      }}
                    />
                    {errorVisible7 && (
                      <div className="login-error-msg mt-2">
                        {errorMessagePurpose}
                      </div>
                    )}
                  </>
                )}

              <div className="lastFilter">
                <h6 className="">State</h6>
                <Select
                  required={true}
                  id="state"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="State"
                  name="state"
                  className="col-12 "
                  styles={customStyles}
                  // value={filterData6}
                  onChange={(e) => {
                    setFilterData6(e.label);
                  }}
                  options={newStateOptions}
                  placeholder="State"
                />
              </div>
            </div>
          </div> */}
          {
           ( loggedIn !== null && loggedIn !== "" && loggedIn !== undefined) &&
           <div
           style={{
             display: "flex",
             flexDirection: "row",
             width: "fit-content",
             float: "right",
             right: "9%",
             // top: "3.5%",
             // fontSize: "14px",
             position: "absolute",
           }}
           className="statusiconsmodal newcompletediconsabove sessionsmodalnewcompletediconsabove"
         >
           {/* {calendarStatus !== "" && ( */}
           <div class="newuserTooltip">
             <div
               className={
                 calendarStatus == ""
                   ? "calendarStatusBtnActive"
                   : "calendarStatusBtn"
               }
               style={{ margin: "5px", cursor: "pointer" }}
               onClick={() => {
                 filterBtnClicked("ALL");
                 setCalendarStatus("");
               }}
             >
               All
             </div>
             <span
               className="tooltiptext tooltip-bottom"
               style={{
                 // left: "165px",
                 // top: "196px",
                 width: "150px",
                 position: "absolute",
                 left: "2px",
               }}
             >
               View All Session
             </span>
           </div>
           {/* )} */}

           <div class="newuserTooltip">
             <div
               className={
                 calendarStatus == "SCHEDULED"
                   ? "calendarStatusBtnActive"
                   : "calendarStatusBtn"
               }
               style={{ margin: "5px", cursor: "pointer" }}
               onClick={() => {
                 filterBtnClicked("SCHEDULED");
               }}
             >
               <FiberManualRecordRounded
                 style={{
                   // width: "0.8em",
                   // marginBottom: "3px",
                   // marginRight: "3px",
                   color: "#b499c7",
                 }}
               />
               Scheduled
             </div>
             <span
               className="tooltiptext tooltip-bottom"
               style={{
                 // left: "165px",
                 // top: "196px",
                 width: "195px",
                 position: "absolute",
                 left: "21px",
               }}
             >
               View Scheduled Session
             </span>
           </div>
           <div class="newuserTooltip">
             <div
               className={
                 calendarStatus == "COMPLETED"
                   ? "calendarStatusBtnActive"
                   : "calendarStatusBtn"
               }
               style={{ margin: "5px", cursor: "pointer" }}
               onClick={() => {
                 filterBtnClicked("COMPLETED");
               }}
             >
               {" "}
               <FiberManualRecordRounded
                 className={
                   calendarStatus == "COMPLETED"
                     ? "calendarStatusBtnActive"
                     : "calendarStatusBtn"
                 }
                 style={{
                   // width: "0.8em",
                   // marginBottom: "3px",
                   // marginRight: "3px",
                   color: "#92a9b0",
                 }}
               />
               Completed
             </div>
             <span
               className="tooltiptext tooltip-bottom"
               style={{
                 // left: "165px",
                 // top: "196px",
                 width: "195px",
                 position: "absolute",
                 left: "21px",
               }}
             >
               View Completed Session
             </span>
           </div>
           <div class="newuserTooltip">
             <div
               className={
                 calendarStatus == "CLOSED"
                   ? "calendarStatusBtnActive"
                   : "calendarStatusBtn"
               }
               style={{ margin: "5px", cursor: "pointer" }}
               onClick={() => {
                 filterBtnClicked("CLOSED");
               }}
             >
               {" "}
               <FiberManualRecordRounded
                 className={
                   calendarStatus == "CLOSED"
                     ? "calendarStatusBtnActive"
                     : "calendarStatusBtn"
                 }
                 style={{
                   // width: "0.8em",
                   // marginBottom: "3px",
                   // marginRight: "3px",
                   color: " #7784d8",
                 }}
               />
               Closed
             </div>
             <span
               className="tooltiptext tooltip-bottom"
               style={{
                 // left: "165px",
                 // top: "196px",
                 width: "195px",
                 position: "absolute",
                 left: "21px",
               }}
             >
               View Closed Session
             </span>
           </div>
           <div class="newuserTooltip">
             <div
               className={
                 calendarStatus == "CANCELLED"
                   ? "calendarStatusBtnActive"
                   : "calendarStatusBtn"
               }
               style={{
                 margin: "5px",
                 marginRight: "15px",
                 cursor: "pointer",
               }}
               onClick={() => {
                 filterBtnClicked("CANCELLED");
               }}
             >
               {" "}
               <FiberManualRecordRounded
                 className={
                   calendarStatus == "CANCELLED"
                     ? "calendarStatusBtnActive"
                     : "calendarStatusBtn"
                 }
                 style={{
                   // width: "0.8em",
                   // marginBottom: "3px",
                   // marginRight: "3px",
                   // color: "#f86880",
                   // color: "#f0516c",
                   // color: "#f65555",
                   color: "#d07979",
                 }}
               />
               Cancelled
             </div>
             <span
               className="tooltiptext tooltip-bottom"
               style={{
                 // left: "165px",
                 // top: "196px",
                 width: "195px",
                 position: "absolute",
                 left: "21px",
               }}
             >
               View Cancelled Session
             </span>
           </div>
         </div>
          }
       

          {props?.allCalendarData !== undefined &&
            props?.allCalendarData !== null &&
            props?.allCalendarData !== "" &&
            props?.allCalendarData && (
              <>
                <Kalend
                  onEventClick={(event) => {
                    cohortgroupsessionfunc(
                      event?.sessionData?.cohortGroupSessionId
                    );
                    setEventdata(event);
                    setSessionModalOpen(true);
                  }}
                  events={
                    allCalendarDataArr?.length > 0
                      ? allCalendarDataArr
                      : newArrayCalendar2
                  }
                  initialDate={new Date().toISOString()}
                  hourHeight={60}
                  initialView={CalendarView.MONTH}
                  disabledViews={[CalendarView.THREE_DAYS]}
                  onPageChange={onPageChange}
                  timeFormat={"12"}
                  weekDayStart={"Sunday"}
                  calendarIDsHidden={["work"]}
                  language={"en"}
                />
              </>
            )}
          {(props?.allCalendarData == undefined ||
            props?.allCalendarData == null ||
            props?.allCalendarData == "" ||
            !props?.allCalendarData) && (
            <>
              <Kalend
                // key={index}
                onEventClick={(event) => {
                  cohortgroupsessionfunc(event?.sessionData?.scheduleId);
                  setEventdata(event);
                  setSessionModalOpen(true);
                }}
                events={
                  allCalendarDataArr?.length > 0
                    ? allCalendarDataArr
                    : newArrayCalendar
                }
                // events={newArrayCalendar}
                // events={events}
                initialDate={new Date().toISOString()}
                hourHeight={60}
                initialView={CalendarView.MONTH}
                disabledViews={[CalendarView.THREE_DAYS]}
                // onSelectView={onPageChange}
                // selectedView={selectedView}
                // showMoreWeek={true}
                onPageChange={onPageChange}
                timeFormat={"12"}
                weekDayStart={"Sunday"}
                calendarIDsHidden={["work"]}
                language={"en"}
              />
                         
            </>
          )}
        </Modal.Body>
        {/* <Modal.Footer className="d-flex justify-content-center">
          <Button
            onClick={handleFilterChanges}
            text="Submit"
            className="modalButton"
          >
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCalendar: state.StartUpReducer.getSessionCalendar,
    cohortMentorData: state.MentorReducer.getCohortMentorList.data,
  };
};

export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getSessionCalendar,
  getMentorCohortApplicationList,
})(withRouter(ModalFilter2));
